var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    rx: 2,
    transform: "rotate(-180 32 32)",
    fill: "#FBFDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8292 12.175L14.6542 16L10.8292 19.825L12.0042 21L17.0042 16L12.0042 11L10.8292 12.175ZM21.1708 21L19.5042 21L19.5042 11L21.1708 11L21.1708 21Z",
    fill: "#2A2859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonRight);
export default __webpack_public_path__ + "static/media/ButtonRight.ee005a58a005aee4668144242c865a4d.svg";
export { ForwardRef as ReactComponent };